var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubbleNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21297_28151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2726 5.04443H3.42612C2.61168 5.04443 1.94531 5.7584 1.94531 6.63102V20.9103L4.90694 17.7371H15.2726C16.0871 17.7371 16.7534 17.0231 16.7534 16.1505V6.63102C16.7534 5.7584 16.0871 5.04443 15.2726 5.04443ZM15.2726 16.1505H4.90694L3.42612 17.7371V6.63102H15.2726V16.1505Z",
    fill: "#323640"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7316 10.8597C18.3868 10.8597 20.5394 8.70738 20.5394 6.05218C20.5394 3.39698 18.3868 1.24463 15.7316 1.24463C13.0764 1.24463 10.9238 3.39698 10.9238 6.05218C10.9238 8.70738 13.0764 10.8597 15.7316 10.8597Z",
    fill: "#F5222D",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21297_28151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7697,
    height: 19.039,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.2695 2.87891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleNotification);
export default __webpack_public_path__ + "static/media/chatBubbleNotification.c3d984515667d608ea7806bfd11119b1.svg";
export { ForwardRef as ReactComponent };